import { render } from "./CGJComponent.vue?vue&type=template&id=545df85d&scoped=true&ts=true"
import script from "./CGJComponent.vue?vue&type=script&lang=ts"
export * from "./CGJComponent.vue?vue&type=script&lang=ts"

import "./CGJComponent.vue?vue&type=style&index=0&id=545df85d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545df85d"]])

export default __exports__